export default class UserACL {
    constructor(user, roles, permissions, queues) {
        if (!Array.isArray(roles)) {
            throw new Error('roles should be an array');
        }

        if (!Array.isArray(permissions)) {
            throw new Error('permissions should be an array');
        }

        this.user = user;
        this.roles = roles || [];
        this.permissions = permissions || [];
        this.queues = (queues || []).map((id) => Number(id));

        Object.freeze(this);
    }

    get id() {
        return this.user && this.user.id;
    }

    get isAuthor() {
        return this.id === 2;
    }

    get isServiceProvider() {
        return this.hasPermissionTo('service-provider');
    }

    get isFromEditorialBoard() {
        return this.hasPermissionTo('editor') || this.hasPermissionTo('editor-assistant');
    }

    get isStaff() {
        return this.hasPermissionTo('admin') || this.hasPermissionTo('staff');
    }

    interactsWithQueue(queue) {
        if (this.user.in_every_queue) {
            return true;
        }

        const queueId = Number(queue && queue.id || 0);

        return (queueId > 0) && this.queues.some((id) => id === queueId);
    }

    hasRole(role) {
        return this.roles.indexOf(role) !== -1;
    }

    hasPermissionTo(permission) {
        return this.permissions.indexOf(permission) !== -1;
    }
}
